module.exports = __webpack_public_path__ + "img/folder.348273e4.svg";